import { VideoReviews } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { VideoReview } from 'app/blocks/sections/VideoReviews/reviews'

export interface IAttributes extends React.ComponentProps<typeof VideoReviews> {
  reviews: VideoReview[]
}

const VideoReviewsBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <VideoReviews
      title={attributes.title}
      background={attributes?.background ?? 'white'}
      reviews={attributes.reviews}
    />
  )
}

export default VideoReviewsBlock
